import { module } from 'angular';
import { DashboardComponent } from './dashboard.component';
import { dashboardRoutesConfig } from './dashboard-routing';
import { dashboardGuard } from './dashboard.guard';
import {
  DashboardSidebarComponent,
  DashboardTopbarComponent,
  TopbarNotificationComponent,
  TopbarStatusNavComponent
} from './components';
import { SidebarItemComponent } from './components/sidebar-item/sidebar-item.component';
import { AdditionalInfoModalModule } from '../../components/modals/additional-info-modal/additional-info-modal.module';
import { dashboardRun } from './dashboard.run';
import { DashboardService } from './dashboard.service';
import { MailboxModule } from '../mailbox/mailbox.module';
export const DashboardModule = module('app.states.dashboard', [
  AdditionalInfoModalModule,
  MailboxModule.name
])
  .component('dashboard', DashboardComponent)
  .component('dashboardTopbar', DashboardTopbarComponent)
  .component('topbarNotification', TopbarNotificationComponent)
  .component('dashboardSidebar', DashboardSidebarComponent)
  .component('sidebarItem', SidebarItemComponent)
  .component('topbarStatusNav', TopbarStatusNavComponent)
  .service(DashboardService.name, DashboardService)
  .config(dashboardRoutesConfig)
  .run(dashboardGuard)
  .run(dashboardRun);



// WEBPACK FOOTER //
// ./app/states/dashboard/dashboard.module.ts